import { apiInitialState }from '../../../utils/reduxOperations';

export default {
    commentsApi:apiInitialState()
};